import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  padding: 3.125rem 15.625rem 3.125rem 5.625rem;

  @media (max-width: 414px) {
    padding: 3.125rem;
  }

  @media (max-width: 280px) {
    padding: 1.875rem;
  }
`;

export const Form = styled.form`
  width: 90%;

  @media (min-width: 425px) {
    width: 50vw;
    margin-left: -45px;
  }

  @media (min-width: 1024px) {
    width: 45vw;
  }

  p {
    color: #333;
  }

  h2 {
    color: #007aff;
    font-size: 1.2rem;
  }
`;

export const InputContainer = styled.div`
  margin: 20px 0;
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 1210px) {
    flex-direction: column;
  }
`;

export const Input = styled.div`
  min-width: 49%;
  margin: 10px 0;

  label {
    display: flex;
    flex-direction: column;
    margin: 5px 0;
    color: #0000ff;

    input,
    select {
      padding: 10px;
      border: 1px solid #d2d2d2;
      border-radius: 5px;
      outline: none;
      color: #747474;
      font-size: 1.2rem;
      margin: 10px 0 20px;
      background: #fff;
      font-family: "Roboto", sans-serif;

      &::placeholder {
        font-size: 1.2rem;
        color: #d2d2d2;
      }
    }
  }
`;
